module.exports = __webpack_public_path__ + "img/B1A395_EFE6E1_635A47_786D5D-256px.bc8f7c15.png";